import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyClUDO4rvtOJsEIPiddWHvnDeszHXZf96A",
  authDomain: "starmarket-f0b1b.firebaseapp.com",
  projectId: "starmarket-f0b1b",
  storageBucket: "starmarket-f0b1b.firebasestorage.app",
  messagingSenderId: "819602972037",
  appId: "1:819602972037:web:38f17f17a4a64e2ed478ec",
  measurementId: "G-W8VNYFCP1N",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
